import { render } from "./CheckClientAdress.vue?vue&type=template&id=cbc9e754&scoped=true"
import script from "./CheckClientAdress.vue?vue&type=script&lang=js"
export * from "./CheckClientAdress.vue?vue&type=script&lang=js"

import "./CheckClientAdress.vue?vue&type=style&index=0&id=cbc9e754&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc9e754"]])

export default __exports__